import Form from './Form';
import Item from './components/Item/Item';
import ColorInput from './components/ColorInput/ColorInput';
import UploadInput from './components/UploadInput';

export default Form;

export {
    Item as FormItem,
    ColorInput,
    UploadInput,
};



// WEBPACK FOOTER //
// ./src/components/Form/index.tsx